import fetch from '@/assets/js/axios.js'
import { v4 as uuidv4 } from 'uuid'
import { FILE_SERVICE_API } from './apis'

function getQueryParams (params) {
  const queryParams = {
    id: uuidv4(),
    timestamp: Date.parse(new Date()),
    version: '1.0',
    params: params
  }
  return queryParams
}

export function deviceFileList (params) {
  return fetch({
    url: FILE_SERVICE_API.DEVICE_FILE_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}
export function syncFile (params) {
  return fetch({
    url: FILE_SERVICE_API.SYNC_FILE,
    method: 'post',
    data: getQueryParams(params)
  })
}
export function querySyncInfo (params) {
  return fetch({
    url: FILE_SERVICE_API.QUERY_SYNC_INFO,
    method: 'post',
    data: getQueryParams(params),
    closeLoading: 1
  })
}
export function queryUploadProgress (params) {
  return fetch({
    url: FILE_SERVICE_API.QUERT_UPLOAD_PROGRESS,
    method: 'post',
    data: getQueryParams(params),
    closeLoading: 1
  })
}
export function syncFileList (params) {
  return fetch({
    url: FILE_SERVICE_API.SYNC_FILE_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}
export function queryIncrFileList (params) {
  return fetch({
    url: FILE_SERVICE_API.QUERY_INCR_FILE_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}
export function downloadFile (params) {
  return fetch({
    url: FILE_SERVICE_API.DEVICE_FILE_DOWNLOAD,
    method: 'post',
    data: getQueryParams(params)
  })
}

export function deleteFile (params) {
  return fetch({
    url: FILE_SERVICE_API.DEVICE_FILE_DELETE,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 固件文件切片上传
export function otaUpLoadFile ({ data, onUploadProgress, headers }) {
  const config = {
    url: FILE_SERVICE_API.CHUNK_FILE_UPLOAD,
    // url: '/test/file-service/v1/file/upload/uploadChunk',
    method: 'post',
    data: data,
    headers: headers,
    closeLoading: true
  }
  onUploadProgress ? config.onUploadProgress = onUploadProgress : ''
  return fetch(config)
}
// 检查文件是否上传
export function otaCheckUploadFile (requestParams) {
  return fetch({
    url: FILE_SERVICE_API.CHUNK_UPLOAD_CHECK,
    // url: '/test/file-service/v1/file/upload/checkFile',
    method: 'post',
    data: {
      params: requestParams.params
    },
    headers: requestParams.headers
  })
}
// 合并文件
export function otaMergeRequest ({ params, headers }) {
  return fetch({
    url: FILE_SERVICE_API.MERGE_FILE_OTA,
    // url: '/test/file-service/v1/file/upload/mergeFileOtaFirmware',
    method: 'post',
    data: {
      params
    },
    headers: headers
  })
}

// 分片上传时候需要服务id
export function getServiceId () {
  return fetch({
    url: FILE_SERVICE_API.GET_SERVICE_ID,
    // url: '/test/file-service/v1/file/upload/getServiceId',
    method: 'get',
    data: {}
  })
}

// 分片上传时候需要uploadId
export function getUploadId (params) {
  return fetch({
    url: FILE_SERVICE_API.GET_UPLOAD_ID,
    method: 'post',
    data: {
      params
    }
  })
}
// 普通文件上传接口
export function previewFileUpload (params) {
  return fetch({
    url: FILE_SERVICE_API.PREVIEW_FILE_UPLOAD,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    closeLoading: true
  })
}

// 文件删除
export function deleteProductFile (params) {
  return fetch({
    url: FILE_SERVICE_API.DELETE_FILE,
    method: 'post',
    data: {
      params
    }
  })
}

//  删除文件
export function deleteImg (params) {
  return fetch({
    url: FILE_SERVICE_API.DELETE_IMG,
    method: 'post',
    data: params
  })
}
